module.exports = __webpack_public_path__ + "static/media/img_05_xs.0bdfdbd3.jpg";